module.exports = __webpack_public_path__ + "img/hint-drag.6ef30cb1.svg";